/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { putAdvancedShippingNotes } from '../fn/advanced-shipping-notice/put-advanced-shipping-notes';
import { PutAdvancedShippingNotes$Params } from '../fn/advanced-shipping-notice/put-advanced-shipping-notes';

@Injectable({ providedIn: 'root' })
export class AdvancedShippingNoticeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `putAdvancedShippingNotes()` */
  static readonly PutAdvancedShippingNotesPath = '/organizationSites/{organizationSiteKey}/consignee/advancedShippingNotes';

  /**
   * Replace advanced shipping notes of an organization site.
   *
   * **Deprecated:** Use `POST /api/v3/organization-sites/{organizationSiteKey}/consignee/advanced-shipping-notes` instead.
   * V3 requires a positive integer `quantity`; omit `item`, `dateCreated`, and `dateUpdated`.
   * Timestamps are generated on the server, and notices are merged by `advancedShippingNotice`
   * instead of replacing the entire list.
   *
   * Replace the advanced shipping notes for a specified organization site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putAdvancedShippingNotes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  putAdvancedShippingNotes$Response(params: PutAdvancedShippingNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = putAdvancedShippingNotes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Replace advanced shipping notes of an organization site.
   *
   * **Deprecated:** Use `POST /api/v3/organization-sites/{organizationSiteKey}/consignee/advanced-shipping-notes` instead.
   * V3 requires a positive integer `quantity`; omit `item`, `dateCreated`, and `dateUpdated`.
   * Timestamps are generated on the server, and notices are merged by `advancedShippingNotice`
   * instead of replacing the entire list.
   *
   * Replace the advanced shipping notes for a specified organization site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putAdvancedShippingNotes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  putAdvancedShippingNotes(params: PutAdvancedShippingNotes$Params, context?: HttpContext): Observable<void> {
    const resp = this.putAdvancedShippingNotes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
